import { render, staticRenderFns } from "./notice-add.vue?vue&type=template&id=debcac98&scoped=true"
import script from "./notice-add.vue?vue&type=script&lang=js"
export * from "./notice-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debcac98",
  null
  
)

export default component.exports